import React, { createContext, useContext, useEffect, useState } from 'react';
import appConfig from 'app.config';
import { TokenStorage } from './token/TokenStorage';
import { setUpLocale } from '../../helpers/dates/dates';

export const AppStateContext = createContext();
export const useAppState = () => useContext(AppStateContext);

const jwtStore = new TokenStorage();
const defaultLang = 'en';

export const AppStateProvider = ({ children }) => {
  const [locale, setLocaleLang] = useState(defaultLang);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const lang =
      appConfig.langs.find(
        lang => lang === navigator?.language?.split('-')[0],
      ) || defaultLang;
    lang !== locale && setLocale(lang);
  }, []);

  const setLocale = locale => {
    setLocaleLang(locale?.toLowerCase());
    setUpLocale(locale);
  };

  const initialState = {
    isLoading,
    setIsLoading,
    locale,
    setLocale,
    jwtStore,
  };

  return (
    <AppStateContext.Provider value={initialState}>
      {children}
    </AppStateContext.Provider>
  );
};
